import * as React from "react";
import images from "../assets/images";

const SocialMediaIcons: React.FC = () => {
  return (
    <div className="flex justify-center gap-6 space-x-4 mt-4">
      <a
        href="https://www.facebook.com/droneden.marketplace"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Facebook"
      >
        <img src={images.facebookLogo} alt="Facebook" />
      </a>
      <a
        href="https://www.instagram.com/droneden.ro/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Instagram"
      >
        <img src={images.instagramLogo} alt="Instagram" />
      </a>
    </div>
  );
};

export default SocialMediaIcons;
